

















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import LineChartComponent from "@/components/packages/apexcharts/LineChartComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import { SensorDetail } from "@/typescript/components/common/parts/sensor_detail_component/types";
import { ApexOptions } from "apexcharts";
import { getRoutePath } from "@/router/routes";
import { getEquipmentsMeasurementApi } from "../../../typescript/api_client/emesh_api/equipments/equipments_measurement_api";
import { getAlertData } from "../../../typescript/lib/common/get_alert_data";
import { Moment } from "@/typescript/lib/common/moment";
import { GetEquipmentsMeasurementResponse } from "../../../typescript/api_client/emesh_api/equipments/types";
export { ApexOptions, SensorDetail, GetEquipmentsMeasurementResponse };
const iconBasePath: string = "/images/icons";

@Component({
  components: {
    LineChartComponent,
    EllipsisComponent
  }
})
export default class SensorDetailComponent extends Vue {
  @Prop()
  sensor!: SensorDetail;

  @Prop({
    default: ""
  })
  detailPosition!: "left-detail" | "right-detail" | "";

  @Prop({
    default: "0px"
  })
  clientTop?: string;

  @Prop({
    default: "auto"
  })
  leftStyle?: string;

  @Prop({
    default: "auto"
  })
  rightStyle?: string;

  get internalSensor(): SensorDetail {
    return this.sensor;
  }

  graphMaxVal: (max: number) => number = (max: number) => {
    return max;
  };

  graphMinVal: (min: number) => number = (min: number) => {
    return min;
  };

  chartOptions: ApexOptions = {
    chart: {
      id: "sensor_detail_chart",
      toolbar: {
        show: false
      },
      animations: {
        enabled: false
      }
    },
    colors: ["#1996D8"],
    xaxis: {
      labels: {
        show: false
      }
    },
    yaxis: {
      labels: {
        show: false
      }
    },
    annotations: {},
    stroke: {
      curve: "smooth"
    }
  };

  get showAlert() {
    if (!this.internalSensor.alerts) return false;
    return this.internalSensor.alerts.length > 0;
  }

  get componentStyle() {
    return {
      top: this.clientTop,
      left: this.detailPosition === "right-detail" ? this.leftStyle : "",
      right: this.detailPosition === "left-detail" ? this.rightStyle : ""
    };
  }

  created() {
    this.setSensorDetailData();
  }

  async setSensorDetailData() {
    if (Object.keys(this.internalSensor).length <= 0) return;

    const apiDatetimeFormat = "YYYYMMDDHHmmss";
    const equipment = await getEquipmentsMeasurementApi({
      equipment_id: this.internalSensor.equipmentId,
      since: new Moment(apiDatetimeFormat).getStartOf("day"),
      until: new Moment(apiDatetimeFormat).getEndOf("day")
    });
    // measurementData は格納順が降順日付で返却されるため、逆順にする
    // もし、パフォーマンスに影響があるなら、配列を用意して for 文で再起処理をした方がよい
    equipment.measurement_data = equipment.measurement_data.reverse();
    this.$set(this.internalSensor, "alertAllCount", equipment.alerts.length);
    this.$set(this.internalSensor, "graphData", [
      {
        data: equipment.measurement_data.map(m => Number(m.temperature))
      }
    ]);
  }

  getBLEIcon(sensitivity: number): string {
    // SDRS_EMESH/docs/仕様/フロントエンド仕様書.adoc に基づき、実装する
    if (sensitivity > -75) return `${iconBasePath}/ic_common_ble-max.png`;
    if (sensitivity >= -85) return `${iconBasePath}/ic_common_ble-nomal.png`;
    if (sensitivity >= -95) return `${iconBasePath}/ic_common_ble-weak.png`;
    return `${iconBasePath}/ic_common_ble-without.png`;
  }

  getBatteryIcon(battery: number): string {
    if (battery >= 51) return `${iconBasePath}/ic_common_battery_100.png`;
    if (battery >= 11) return `${iconBasePath}/ic_common_battery_50.png`;
    if (battery >= 1) return `${iconBasePath}/ic_common_battery_10.png`;
    return `${iconBasePath}/ic_common_battery_empty.png`;
  }

  getAlert(): string {
    if (!this.internalSensor.alerts) return "";
    return this.internalSensor.alerts
      .map(
        a =>
          `${
            getAlertData(a.id, this.internalSensor.alertStatus as 0 | 1 | 2).msg
          }`
      )
      .join(" ");
  }

  getGraphData(sensor: SensorDetail) {
    return sensor.graphData;
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }
}
